import ModelBaseClass from "@quasidea/oas-client-react/lib/ModelBaseClass";
import ReconciliationItem from "../ReconciliationItem";
import ModelProxyClass from "./ModelProxyClass";
import Person from "../Person";
import ReconciliationLineItem from "../ReconciliationLineItem";


/**
 * @class ReconciliationItemBase
 * @extends ModelBaseClass
 * @property {number} id (int64)
 * @property {number} tenantId (int64)
 * @property {Person} person
 * @property {[ReconciliationLineItem]} reconciliationLineItems
 * @property {Date} dateCreated (date and time)
 */
class ReconciliationItemBase extends ModelBaseClass {
	/**
	 * @type {number} id (int64)
	 */
	id;
	/**
	 * @type {number} tenantId (int64)
	 */
	tenantId;
	/**
	 * @type {Person} person
	 */
	person;
	/**
	 * @type {[ReconciliationLineItem]} reconciliationLineItems
	 */
	reconciliationLineItems;
	/**
	 * @type {Date} dateCreated (date and time)
	 */
	dateCreated;

	/**
	 * Instantiates a new instance of ReconciliationItem based on the generic object being passed in (typically from a JSON object)
	 * @param {object} genericObject
	 * @return {ReconciliationItem}
	 */
	static create(genericObject) {
		const newReconciliationItem = new ReconciliationItem();
		newReconciliationItem.instantiate(_modelDefinition, genericObject, ModelProxyClass.createByClassName);
		return newReconciliationItem;
	}

	/**
	 * Instantiates a new array of ReconciliationItem based on the generic array being passed in (typically from a JSON array)
	 * @param {[object]} genericArray
	 * @return {[ReconciliationItem]}
	 */
	static createArray(genericArray) {
		if (genericArray === null) {
			return null;
		}

		const newReconciliationItemArray = [];
		genericArray.forEach(genericObject => {
			newReconciliationItemArray.push(ReconciliationItem.create(genericObject));
		});
		return newReconciliationItemArray;
	}
}

const _modelDefinition = [
	ModelBaseClass.createModelProperty('id', 'integer'),
	ModelBaseClass.createModelProperty('tenantId', 'integer'),
	ModelBaseClass.createModelProperty('person', 'Person'),
	ModelBaseClass.createModelProperty('reconciliationLineItems', '[ReconciliationLineItem]'),
	ModelBaseClass.createModelProperty('dateCreated', 'datetime'),
];

export default ReconciliationItemBase;
